import React from 'react';
import { Error404 } from '../../asset';
import PrimaryButton from '../../component/button/PrimaryButton';
import { t } from 'i18next';

const ErrorPage404 = () => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <img src={Error404} alt='img-error-400' />
      <p className='font-sans font-bold text-4xl mt-[24px]'> Something’s Missing </p>
      <p className='font-sans font-bold text-2xl mt-[24px]'> 
        This page doesn’t exist or was removed
      </p>
      <p className='font-sans font-bold text-2xl '> 
        We suggest you back to home
      </p>
      <PrimaryButton 
          styles='mt-[24px]'
          // action={() => setStartOpen(true)} 
          text={t("Back To Home")} 
        />
    </div>
  );
}

export default ErrorPage404;